<template>
  <!-- 热爱值商城海报页面 -->
  <img
    class="love-value-mall-poster"
    src="../../assets/chaofandashi/love_value_mall_poster.jpg"
  />
</template>
<script>
export default {
  created() {
    document.title = this.$route.meta.title;
  },
};
</script>
<style lang="less" scoped>
.love-value-mall-poster {
  width: 100%;
  height: auto;
}
</style>
